module.exports = __webpack_public_path__ + "media/images/emblems/Bellmund-coat_of_arms-2f7df15ca86d8b66e393637c6aa6a346.svg";